import React from 'react'
import WaterfallItem from './item'

export default class Waterfall extends React.Component {
  state = {
    images: this.props.images,
    rows: this.props.rows || 4,
    group: {}
  }

  componentWillMount() {
    this.setState({group: this.group()})
  }

  // 对图片分组
  group = () => {
    let group = {}
    let heights = new Array(this.state.rows).fill(0)
    this.props.images.map((image) => {
      const row = heights.findIndex(height => height === Math.min.apply(null, heights))
      if (!group[row]) group[row] = []
      group[row].push(image)
      heights[row] += (image.height || 1) / (image.width || 1)
    })
    return group
  }

  render() {
    const group = this.state.group
    return (
      <div className="gallery-waterfall-list">
        {Object.keys(group).map((row) =>
          <div className={`gallery-waterfall-item-wrap col-sm-${12 / this.state.rows}`}
               key={'waterfall-row-' + row}>
            {group[row].map((image, index) =>
              <div className="clearfix" key={"gallery-waterfall-item-"+index}>
                <WaterfallItem media={image} />
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/gallery/waterfall/index.js